import { Modal, Row, Col, Table } from "react-bootstrap";
import { FiFileText, FiCalendar } from "react-icons/fi";

export default function InvoiceModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className="p-4">

        {/* HEADER */}
        <Row className="mb-4 align-items-center">
          <Col md={6}>
            <img
              src="/assets/img/logo-1.svg"
              alt="logo"
              style={{ height: "40px" }}
            />
          </Col>

          <Col md={6} className="text-md-end mt-3 mt-md-0">
            <h5 className="mb-2">Invoice</h5>
            <p className="mb-1">
              <FiFileText className="me-1" /> INV0287
            </p>
            <p className="mb-1">
              <FiCalendar className="me-1" /> Issue date : 12 Sep 2024
            </p>
            <p>
              <FiCalendar className="me-1" /> Due date : 12 Oct 2024
            </p>
          </Col>
        </Row>

        {/* FROM / TO */}
        <Row className="mb-4">
          <Col md={7}>
            <h6 className="fw-semibold mb-2">Invoice From :</h6>
            <p className="mb-1">SmartHR</p>
            <p className="mb-1">
              367 Hillcrest Lane, Irvine, California, United States
            </p>
            <p>[email protected]</p>
          </Col>

          <Col md={5} className="text-md-end mt-3 mt-md-0">
            <h6 className="fw-semibold mb-2">Invoice To :</h6>
            <p className="mb-1">BrightWave Innovations</p>
            <p className="mb-1">
              367 Hillcrest Lane, Irvine, California, United States
            </p>
            <p>[email protected]</p>
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive mb-4">
          <Table className="invoice-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th className="text-end">Billing Cycle</th>
                <th className="text-end">Created Date</th>
                <th className="text-end">Expiring On</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Advanced (Monthly)</td>
                <td className="text-end">30 Days</td>
                <td className="text-end">12 Sep 2024</td>
                <td className="text-end">12 Oct 2024</td>
                <td className="text-end">$200</td>
              </tr>
            </tbody>
          </Table>
        </div>

        {/* PAYMENT + TOTAL */}
        <Row className="mb-4">
          <Col md={6}>
            <h6 className="fw-semibold mb-3">Payment info:</h6>
            <p className="mb-1">Credit Card - 123***********789</p>
            <div className="d-flex justify-content-between">
              <span>Amount</span>
              <strong>$200.00</strong>
            </div>
          </Col>

          <Col md={6} className="mt-3 mt-md-0">
            <div className="d-flex justify-content-between">
              <span>Sub Total</span>
              <span>$200.00</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Tax</span>
              <span>$0.00</span>
            </div>
            <div className="d-flex justify-content-between fw-semibold">
              <span>Total</span>
              <span>$200.00</span>
            </div>
          </Col>
        </Row>

        {/* TERMS */}
        <div className="terms-box p-3">
          <h6 className="mb-2">Terms & Conditions:</h6>
          <ul className="mb-0">
            <li>
              All payments must be made according to the agreed schedule. Late
              payments may incur additional fees.
            </li>
            <li>
              We are not liable for any indirect, incidental, or consequential
              damages.
            </li>
          </ul>
        </div>

      </Modal.Body>
      <style>{
          
          `
          import { Modal, Row, Col, Table } from "react-bootstrap";
import { FiFileText, FiCalendar } from "react-icons/fi";

export default function InvoiceModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className="p-4">

        {/* HEADER */}
        <Row className="mb-4 align-items-center">
          <Col md={6}>
            <img
              src="/assets/img/logo-1.svg"
              alt="logo"
              style={{ height: "40px" }}
            />
          </Col>

          <Col md={6} className="text-md-end mt-3 mt-md-0">
            <h5 className="mb-2">Invoice</h5>
            <p className="mb-1">
              <FiFileText className="me-1" /> INV0287
            </p>
            <p className="mb-1">
              <FiCalendar className="me-1" /> Issue date : 12 Sep 2024
            </p>
            <p>
              <FiCalendar className="me-1" /> Due date : 12 Oct 2024
            </p>
          </Col>
        </Row>

        {/* FROM / TO */}
        <Row className="mb-4">
          <Col md={7}>
            <h6 className="fw-semibold mb-2">Invoice From :</h6>
            <p className="mb-1">SmartHR</p>
            <p className="mb-1">
              367 Hillcrest Lane, Irvine, California, United States
            </p>
            <p>[email protected]</p>
          </Col>

          <Col md={5} className="text-md-end mt-3 mt-md-0">
            <h6 className="fw-semibold mb-2">Invoice To :</h6>
            <p className="mb-1">BrightWave Innovations</p>
            <p className="mb-1">
              367 Hillcrest Lane, Irvine, California, United States
            </p>
            <p>[email protected]</p>
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive mb-4">
          <Table className="invoice-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th className="text-end">Billing Cycle</th>
                <th className="text-end">Created Date</th>
                <th className="text-end">Expiring On</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Advanced (Monthly)</td>
                <td className="text-end">30 Days</td>
                <td className="text-end">12 Sep 2024</td>
                <td className="text-end">12 Oct 2024</td>
                <td className="text-end">$200</td>
              </tr>
            </tbody>
          </Table>
        </div>

        {/* PAYMENT + TOTAL */}
        <Row className="mb-4">
          <Col md={6}>
            <h6 className="fw-semibold mb-3">Payment info:</h6>
            <p className="mb-1">Credit Card - 123***********789</p>
            <div className="d-flex justify-content-between">
              <span>Amount</span>
              <strong>$200.00</strong>
            </div>
          </Col>

          <Col md={6} className="mt-3 mt-md-0">
            <div className="d-flex justify-content-between">
              <span>Sub Total</span>
              <span>$200.00</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Tax</span>
              <span>$0.00</span>
            </div>
            <div className="d-flex justify-content-between fw-semibold">
              <span>Total</span>
              <span>$200.00</span>
            </div>
          </Col>
        </Row>

        {/* TERMS */}
        <div className="terms-box p-3">
          <h6 className="mb-2">Terms & Conditions:</h6>
          <ul className="mb-0">
            <li>
              All payments must be made according to the agreed schedule. Late
              payments may incur additional fees.
            </li>
            <li>
              We are not liable for any indirect, incidental, or consequential
              damages.
            </li>
          </ul>
        </div>

      </Modal.Body>
    </Modal>
  );
}`}</style>
    </Modal>
  );
}